import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import { Briefcase, Share2, Monitor, Factory, RotateCw } from 'lucide-react';
import UserFirstExperienceSection from '../../Components/servicex/UserFirstExperienceSection'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import IndustriesServiceExperienceSection from '../../Components/servicex/IndustriesServiceExperienceSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import OtherExpertLedSolutionsSection from '../../Components/servicex/OtherExpertLedSolutionsSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import { Helmet } from "react-helmet-async";

const serviceItems = [
    {
        id: 1,
        title: "Develop a clear innovation strategy aligned with business goals",
        description: "Define actionable digital blueprints that align cutting-edge technology investments directly with measurable enterprise outcomes and growth.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Accelerate AI-driven innovation across operations and services",
        description: "Deploy generative AI and machine learning models across critical workflows to automate decision-making and elevate operational agility.",
        image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Automate complex processes with intelligent workflows",
        description: "Eliminate friction and orchestrate cross-departmental tasks seamlessly with autonomous, self-optimizing business processes.",
        image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 4,
        title: "Build digital applications faster through low-code engineering",
        description: "Empower business and development teams to rapidly construct scalable, enterprise-grade applications with modern low-code foundations.",
        image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 5,
        title: "Deliver intuitive digital experiences through human-centered design",
        description: "Craft modern, accessible, and frictionless user interfaces that elevate engagement and drive self-service adoption across portals.",
        image: "https://images.unsplash.com/photo-1531403009284-440f080d1e12?auto=format&fit=crop&w=1000&q=80"
    }
];
const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "AI Innovation",
        desc: "We help enterprises realize the value of AI and innovation by embedding intelligence directly into business workflows and decision-making processes.",
        products: []
    },
    {
        id: 2,
        title: "Intelligent Automation",
        desc: "We design intelligent automation frameworks that eliminate repetitive work, accelerate processes, and enable autonomous operations across enterprise functions.",
        products: []
    },
    {
        id: 3,
        title: "Low-Code Development",
        desc: "Our Low code development capabilities help organizations accelerate innovation by enabling faster development of scalable enterprise solutions.",
        products: []
    },
    {
        id: 4,
        title: "Aelum Design Studio",
        desc: "Aelum Design Studio applies human-centered design principles to build digital interfaces that improve adoption and usability.",
        products: []
    }
];


const industryTabs = [
    {
        id: "manufacturing",
        label: "Manufacturing",
        title: "Manufacturing",
        desc: "We help manufacturers drive digital innovation across production, maintenance, and supply chain operations through intelligent automation and AI-powered insights.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "bfsi",
        label: "BFSI",
        title: "BFSI",
        desc: "Our innovation frameworks enable financial institutions to modernize operations, enhance customer experiences, and maintain compliance in highly regulated environments.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "retail",
        label: "Retail",
        title: "Retail",
        desc: "Retail organizations leverage our AI-driven innovation capabilities to improve customer engagement, optimize operations, and deliver seamless omnichannel experiences.",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "telecom",
        label: "Telecommunication",
        title: "Telecommunication",
        desc: "We help telecom providers innovate across customer service, network operations, and field service through intelligent workflows and scalable digital platforms.",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "Dedicated Tribes",
        desc: "Our dedicated experts apply deep knowledge and hands-on capability to deliver precise solutions and faster results."
    },
    {
        id: 2,
        title: "Continuous Improvement",
        desc: "We continuously refine controls and processes to strengthen resilience and keep pace with evolving risks and regulations."
    },
    {
        id: 3,
        title: "Cross-Platform Capabilities",
        desc: "We integrate risk, security, and compliance workflows across systems for unified visibility and coordinated enterprise-wide control."
    },
    {
        id: 4,
        title: "AI-Driven Approach",
        desc: "We use AI and automation to detect risks faster, improve response speed, and enhance decision-making across the enterprise."
    }
];


const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];

const faqData = [
    {
        id: 1,
        question: "What does enterprise innovation mean in today's business context?",
        answer: "Enterprise innovation means rapidly translating emerging technologies—like generative AI, low-code platforms, and automated workflows—into scalable operational capabilities that deliver measurable business value."
    },
    {
        id: 2,
        question: "How is Aelum's innovation approach different from traditional digital transformation?",
        answer: "Instead of long, rigid transformation cycles, we focus on outcome-driven, modular innovation. We combine design thinking, rapid low-code prototyping, and embedded AI directly inside existing workflows for faster time-to-value."
    },
    {
        id: 3,
        question: "How do you help enterprises move from AI experimentation to execution?",
        answer: "We bridge the gap between proof-of-concept and production by integrating robust AI models and Now Assist capabilities directly into day-to-day enterprise platforms, complete with enterprise-grade governance and security."
    },
    {
        id: 4,
        question: "What types of business problems can innovation services solve?",
        answer: "They eliminate operational bottlenecks, modernize legacy multi-system processes, overcome manual workflow delays, enhance customer/employee digital journeys, and enable agile application delivery."
    },
    {
        id: 5,
        question: "How does AI-driven innovation improve business outcomes?",
        answer: "It dramatically reduces processing times, eliminates repetitive manual errors, surfaces predictive operational insights, and allows workforce bandwidth to shift toward high-impact strategic tasks."
    },
    {
        id: 6,
        question: "Which industries benefit most from AI-driven innovation?",
        answer: "Data-intensive and service-critical industries such as BFSI, Manufacturing, Healthcare, Retail, and Telecommunications see the highest impact through automated decision-making and streamlined end-to-end operations."
    }
];


function Innovation() {
    return (
        <div>
            <Helmet>
    {/* Primary SEO */}
    <title>
        AI Innovation & Intelligent Automation Solutions | Mobikode
    </title>

    <meta
        name="description"
        content="Accelerate enterprise innovation with Mobikode's AI solutions, intelligent automation, low-code development, and human-centered design. Transform workflows, scale digital applications, and drive business growth."
    />

    <meta
        name="keywords"
        content="AI Innovation, Enterprise AI Solutions, Generative AI Solutions, Intelligent Automation, AI Consulting Services, ServiceNow AI, ServiceNow Now Assist, ServiceNow AI Solutions, Low-Code Development, Enterprise Digital Transformation, AI Workflow Automation, Business Process Automation, Digital Engineering, AI Driven Innovation, Enterprise Application Development, Human Centered Design, Digital Experience Design, ServiceNow Consulting, AI Implementation Services, Mobikode"
    />

    {/* Robots */}
    <meta
        name="robots"
        content="index, follow, max-image-preview:large"
    />

    <meta
        name="googlebot"
        content="index, follow"
    />

    {/* Canonical */}
    <link
        rel="canonical"
        href="https://www.mobikode.com/innovation"
    />

    {/* Open Graph */}
    <meta
        property="og:title"
        content="AI Innovation & Intelligent Automation Solutions | Mobikode"
    />

    <meta
        property="og:description"
        content="Transform enterprise operations with AI innovation, intelligent automation, low-code development, and modern digital engineering solutions from Mobikode."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/innovation"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:site_name"
        content="Mobikode"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/glodesk/bg2.png"
    />

    <meta
        property="og:image:alt"
        content="Mobikode AI Innovation and Intelligent Automation Solutions"
    />

    {/* Twitter */}
    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="AI Innovation & Intelligent Automation Solutions | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Scale enterprise innovation with AI, intelligent automation, low-code development, and human-centered digital experiences."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/glodesk/bg2.png"
    />

    {/* Structured Data */}
    <script type="application/ld+json">
        {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "AI Innovation & Intelligent Automation Solutions",
            "serviceType": "Enterprise AI and Digital Innovation",
            "description":
                "Mobikode provides enterprise AI innovation, intelligent automation, low-code development, digital engineering, and human-centered design solutions to help organizations transform business workflows and accelerate Enterprise AI & ServiceNow Consulting Company.",
            "provider": {
                "@type": "Organization",
                "name": "Mobikode",
                "url": "https://www.mobikode.com/"
            },
            "areaServed": {
                "@type": "Place",
                "name": "Worldwide"
            },
            "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Innovation and AI Services",
                "itemListElement": [
                    {
                        "@type": "OfferCatalog",
                        "name": "AI Innovation"
                    },
                    {
                        "@type": "OfferCatalog",
                        "name": "Intelligent Automation"
                    },
                    {
                        "@type": "OfferCatalog",
                        "name": "Low-Code Development"
                    },
                    {
                        "@type": "OfferCatalog",
                        "name": "Human-Centered Digital Design"
                    }
                ]
            },
            "url": "https://www.mobikode.com/innovation"
        })}
    </script>

</Helmet>
            <WhoHero
                title="Think. Build. Transform."
                text="Design, automate, and scale enterprise capabilities with AI, intelligent workflows, and modern digital platforms"
                imgData="/assets/glodesk/bg2.png"
            />
            <UserFirstExperienceSection title="Supercharge enterprises with AI-Driven Innovation" description="Innovation today goes beyond experimenting with new technologies. Organizations need to turn ideas into solutions that improve operations, create better experiences, and drive measurable results. Many enterprises explore AI, automation, and digital tools but struggle to scale them across the business. Mobikode helps organizations move from experimentation to execution. By combining AI capabilities, intelligent automation, and digital engineering, we help enterprises build scalable solutions that improve efficiency, enable faster decisions, and support long-term growth." />
            <ServiceX360ViewSection title="Scale, Optimize, and Automate How Work Gets Done" description="Mobikode helps organizations build a structured innovation approach that connects technology, workflows, and business goals. This allows teams to experiment, develop new capabilities, and scale them across the enterprise. With our approach, organizations can" serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our Full-Suite of Innovation Offerings" description="Mobikode enables enterprises to operationalize innovation through a structured set of capabilities designed to transform ideas into scalable digital solutions." />
            <IndustriesServiceExperienceSection title="Accelerating Innovation Across Industries" industryTabs={industryTabs} />
            <WhatSetsApartSection title="Mobikode for Innovation" description="" apartData={apartData} />
            <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} />
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default Innovation
